import React from "react";
import ajax from "../ajax";

/**
 * @typedef DynamicContentProps
 * @property {string} className
 * @property {boolean} textOnly
 * @property {any} children
 * @property {string} contentName
 * @property {"People" | "Supervisor" | "PayrollAdmin" | "Marketing" | undefined | null} role
 * @property {number | undefined | null} userId
 */

/**
 * @class
 * @extends React.Component<DynamicContentProps>
 */
export default class DynamicContent extends React.Component {

    /**
     * @param {DynamicContentProps} props 
     */
    constructor(props) {
        super(props);
        this.state = {
            loadedContent: null,
            isLoaded: false
        };
    }

    componentDidMount() {
        /** @type {DynamicContentProps} */
        const props = this.props;
        if (!this.state.isLoaded && props.contentName) {
            (async () => {
                let url = `/get-content/${props.contentName}`;
                const queryParams = []

                if (!!props.role){
                    queryParams.push(`userRole=${encodeURIComponent(props.role)}`);
                }

                if(props.userId != null) {
                    queryParams.push(`userId=${encodeURIComponent(props.userId)}`);
                }
                
                if (queryParams.length > 0) {
                    url += `?${queryParams.join("&")}`;
                }

                const response = await ajax.api().get(url);
              
                this.setState({
                    isLoaded: true,
                    loadedContent: response.data
                });
            })();
        }
    }

    render() {
        let { className, textOnly, children } = this.props;
        className = className || "";
        
        if (this.state.isLoaded) {
            if (this.state.loadedContent != null) {
                if (textOnly) {
                    return <div className={className}>{this.state.loadedContent}</div>
                } else {
                    return <div className={className} dangerouslySetInnerHTML={{ __html: this.state.loadedContent }}></div>
                }
            } else {
                return <div className={className}>{children}</div>;
            }
        } else {
            return <div className={className}></div>;
        }
    }
}